import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  FormContainerSkin: () => [
    import(
      './viewer/skinComps/FormContainerSkin/FormContainerSkin.skin' /* webpackChunkName: "FormContainer_FormContainerSkin" */
    ),
    import(
      './viewer/FormContainer.controller' /* webpackChunkName: "FormContainer_FormContainerSkin" */
    ),
  ],
  ResponsiveSkin: () => [
    import(
      './viewer/skinComps/ResponsiveSkin/ResponsiveSkin.skin' /* webpackChunkName: "FormContainer_ResponsiveSkin" */
    ),
  ],
  '': () => [
    import(
      './viewer/FormContainer' /* webpackChunkName: "FormContainerSkin" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('FormContainer', UiTypes),
};

export default entry;
